import {Space} from "antd";
import {ProductCoverImagesFormFieldsProps} from "./types";
import {NewOfferingCoverImagesUpload} from "../../general/cover-images";

export function ProductCoverImagesFormFields({
  accordionIndex,
  defaultCoverImages,
  deleteCoverImage,
  isDeleteLoading,
  isUploadLoading,
  offeringId,
  uploadCoverImages,
}: ProductCoverImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <NewOfferingCoverImagesUpload
        defaultCoverImages={defaultCoverImages}
        deleteCoverImage={deleteCoverImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        offeringId={offeringId}
        uploadCoverImages={uploadCoverImages}
        offeringType="product"
      />
    </Space>
  );
}
